import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import type { Client } from 'src/pages/client-management/types/client.types';
import type { LaunchedCampaign } from '../types/campaigns.types';

interface CampaignClientSelectProps {
  campaign: LaunchedCampaign;
  clients: Client[];
  disabled?: boolean;
  onAssign: (campaignId: string, clientExtClientId: string) => Promise<void>;
}

export function CampaignClientSelect({
  campaign,
  clients,
  disabled = false,
  onAssign,
}: CampaignClientSelectProps) {
  const value = campaign.clientExtClientId ?? '';

  return (
    <label className={cn(portalDs.field, 'min-w-[180px]')}>
      <span className="sr-only">
        Assign client for
        {' '}
        {campaign.name}
      </span>
      <select
        className={portalDs.select}
        value={value}
        disabled={disabled}
        onChange={(event) => {
          const nextValue = event.target.value;
          if (!nextValue || nextValue === value) {
            return;
          }
          void onAssign(campaign.id, nextValue);
        }}
      >
        <option value="">
          Select client…
        </option>
        {clients.map((client) => (
          <option
            key={client.ext_client_id}
            value={client.ext_client_id}
          >
            {client.title}
          </option>
        ))}
      </select>
    </label>
  );
}
